import { RecordWithImageFields } from '@akin-home/images';
import { useImageUrl } from './useImageUrl';

interface Params {
  record?: RecordWithImageFields;
  edits?: any;
  config?: any;
}

/** A record image hook generator, which can take an object pointing to local image assets */
export const makeRecordImageHook = (init_params?: {
  local_images?: { [key: string]: any };
}) => {
  return (params: Params) => {
    const { record, edits, config } = params;

    const { data, isLoading } = useImageUrl({
      image: record?.image ?? undefined,
      edits,
      config,
    });

    const uri =
      record?.imageUpload?.path ||
      record?.customPictureURL ||
      record?.imageUrl ||
      data ||
      (record?.profilePicture &&
        init_params?.local_images?.[record.profilePicture]);

    const source = !uri ? undefined : typeof uri === 'string' ? { uri } : uri;

    return { uri, source, isLoading };
  };
};

/** Default useRecordImage hook */
export const useRecordImage = makeRecordImageHook();
